<!-- <div *ngIf="appAdmin() ;else user"> -->
    <section *ngIf="errorMessage">
        <div class="container" style="margin-top: 20px;">
            <div class="row">
                <p class="h4 text-danger">{{errorMessage}}</p>
            </div>
        </div>
        </section>
    
    <!-- <mat-card style="width: 1376px;height: 750px"> -->
        <div style="justify-content:center;display: flex;">
        <mat-card appearance="outlined" style="height: 750px;margin-right: 0px;width: 1376px;">
            <td style="width: 125px;"> <button class="buttonHeaderHome" *ngIf="appAdmin()" [routerLink]="['../newassessment/0000']">New Assessment</button></td>
            <ng2-smart-table [settings]="settings" [source]="data" align="left"></ng2-smart-table>
            <!-- (userRowSelect)="onUserRowSelect($event)" -->
        </mat-card>
    </div>




